// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"872":"26b50db8","2992":"26b50db8","7911":"26b50db8","8688":"6a7ad95e"}[chunkId] + ".chunk.css";
};